<template>
    <div class="body">
        <!-- 海报区域 -->
        <div class="poster">
            <p style="font-size: 1.5rem;color: aliceblue;font-weight: bold;text-align: center;margin: 0;">2025年你希望自己</p>
            <div class="buttons-container">
                <button v-for="button in buttons" :key="button.id" :class="['float-button', { active: selectedButtonId === button.id }]" :style="button.style" @click="selectButton(button.id)">
                    {{ button.label }}
                </button>
            </div>
        </div>
        <!-- 按钮 -->
        <!-- <div class="btn">
            <button @click="drawer=true">学习计划</button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button @click="detailSave()">期望</button>
        </div> -->
        <!-- 学习计划 -->
        <transition name="fade">
            <div class="course-container" v-if="drawer">
                <label class="close-btn">
                    <i class="fa fa-close fa-lg" @click="drawer=false"></i>
                </label>
                <div class="course"> 
                    <div v-if="selectedButtonId=='btn1'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">匠心稳行者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">坚持精益求精，用稳健的步伐走向成功</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn2'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">边界探索者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">拓展新领域，发现更多的可能性​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn3'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">高效执行者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">以高效为翼，以行动为舟，驶向卓越​​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn4'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">突破创新者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">敢于打破常规，用创意点燃未来​​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn5'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">实用主义者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">将知识化为力量，用实践书写成长​​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn6'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">成长驱动者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">自我驱动，追逐更高目标，实现无限可能​​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn7'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">协同合作者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">与团队携手并肩，共创更大价值​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn8'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">晋升挑战者</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">向目标迈进，迎接更多可能性​​</p>
                    </div>
                    <div v-else-if="selectedButtonId=='btn9'">
                        <p class="font1" style="padding-top: 11vh;color:#fff">全面进阶者​</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">凭更多维成长，爱上更美好的自己​​</p>
                    </div>
                    <div v-else>
                        <p class="font1" style="padding-top: 11vh;color:#fff">执行践行者​​</p>
                        <p class="font1" style="padding-top: 1vh;color:#fff">学以致用，以行动实践知识的最大价值​​</p>
                    </div>
                <div>
                       
                        <p class="font2" style="padding-top: 3vh;">你希望在富学宝典平台遇见哪些好课程？</p>
                        <p class="font2" style="padding-top: 1vh;">请写下你2025年的学习清单吧！</p>
                    </div>
                    <div style="display:flex;flex-wrap:wrap;justify-content:center;margin-top: 3vh;">
                         
                        <div class="wrapper">
                            <textarea placeholder="请写下你的学习清单吧！" v-model="comment" class="text" name="text" rows="4" style="overflow: hidden; word-wrap: break-word; resize: none; height: 127px; "></textarea>
                        </div>
                        <button @click="submit">提交</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ["ReportData"],
    data(){
        return{
            drawer:false,
            // detail:false,
            comment: '',
            studyList: '',
            buttons: [
                { id: 'btn1', label: '稳中求进', style: { top: '20px', left: '50px' } },
                { id: 'btn2', label: '拓宽边界', style: { top: '80px', left: '150px' } },
                { id: 'btn3', label: '高效执行', style: { top: '90px', left: '0px' } },
                { id: 'btn4', label: '创新突破', style: { top: '140px', left: '140px' } },
                { id: 'btn5', label: '学以致用', style: { top: '170px', left: '10px' } },
                { id: 'btn6', label: '自我驱动', style: { top: '200px', left: '160px' } },
                { id: 'btn7', label: '共赢合作', style: { top: '240px', left: '1px' } },
                { id: 'btn8', label: '职业晋升', style: { top: '280px', left: '180px' } },
                { id: 'btn9', label: '全面发展', style: { top: '300px', left: '50px' } },
                { id: 'btn10', label: '知行合一', style: { top: '350px', left: '150px' } },
            ],
            selectedButtonId: null
        }
    },
    methods:{
        // 点击按钮时调用此方法
        selectButton(id) {
            this.selectedButtonId = id;
            if (this.selectedButtonId) {
            // 获取选中按钮的 label
                const selectedButton = this.buttons.find(button => button.id === this.selectedButtonId);
                const labelToSave = selectedButton ? selectedButton.label : null;
                console.log(labelToSave)
                if (labelToSave) {
                    // 模拟保存到数据库的 API 调用
                    const view = {
                        posterType: labelToSave,
                    }
                    this.drawer=true
                    this.$emit('detailSave',view)
                }
            } else {
                this.$message({
                    message: '请选择你对自己的期望',
                    type: 'warning',
                    center: true
                });
            }
        },
        submit(){
            this.studyList = ''
            if(!this.comment) {
                this.$message({
                    message: '请说说您的学习计划',
                    type: 'warning',
                    center: true
                })
                return
            }else{
                this.drawer=false
            }
            const view = {
                comment: this.comment,
                studyList: this.studyList
            }
            this.$emit('submit',view)
        }
    },
}
</script>

<style scoped>
.body{
    height: 100vh;
    width: 100%;
    /* background: linear-gradient(to bottom, #add6dc, #c7cceb, #e7e6f4, #d5d0e0, #dbd8df); */
    background:url("../../assets/24year/bg2.jpg")  no-repeat;
    background-size: 100% 100%,cover;
}

.poster{
    position: absolute;
    top: 10%;
    left:50%;
    transform:translateX(-50%); 
    height: 58vh;
    width: 70%;
}
/*  */
.btn{
    position: absolute;
    bottom:13%;
    display: flex;
    justify-content: center;
    width: 100%;
}
button {
    background: #FBCA1F;
    font-family: inherit;
    padding: 0.6em 1.3em;
    font-weight: 900;
    font-size: 15px;
    border: 2px solid black;
    border-radius: 5px;
    box-shadow: 1px 1px;
}

button:active {
    transform: translate(0.05em, 0.05em);
    box-shadow: 0.05em 0.05em;
}
.course-container{
    position: fixed;
    width: 100%;
    height: 100%; 
    background:url("../../assets/24year/bg2.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    transition: opacity 0.5s;
}
.detail-container{
    position: fixed;
    width: 100%;
    height: 100%; 
    background:url("../../assets/24year/bg1.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    transition: opacity 0.5s;
}
.close-btn{
   margin-left: 95%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.font1{
    width: 90%;
    margin: 0 auto;
    text-align:center;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.wrapper {
    width: 87%;
    height: auto;
    margin-bottom: 21px;
    display: flex;
    justify-content: center;
}
.text {
    width: 270px;
    overflow: hidden;
    background-color:rgba(227, 217, 216, 0.62);
    color: #953b5d;
    font-family: Courier, monospace;
    font-weight: normal;
    font-size: 21px;
    resize: none;
    line-height: 40px;
    padding-left: 27px;
    padding-right: 27px;
    padding-top: 25px;
    padding-bottom: 21px;
    background-repeat: repeat-y, repeat;
    -webkit-border-radius: 12px;
    border-radius: 12px;
    -webkit-box-shadow: 0px 2px 14px #000;
    box-shadow: 0px 2px 14px #000;
    border-top: 1px solid rgb(6, 142, 140);
    border-bottom: 1px solid rgb(6, 142, 140);
}
.text:focus {
    outline: none; 
}
/* 按钮样式 */
.buttons-container {
    position: relative; /* 让子元素的绝对定位基于这个容器 */
    height: 100vh; /* 设置容器高度为视口高度 */
}

.float-button {
    /* 浮动按钮的基础样式 */
    position: absolute;
    width: 120px;
    height: 40px;
    border-radius: 4px;
    background-color: #1c80eb;
    color: white;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: float 4s ease-in-out infinite;
}

.float-button:hover {
    background-color: #0056b3;
}

.float-button.active {
    background-color: #28a745;
    animation: none; /* 停止动画 */
}
@keyframes float {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px); /* 上下浮动的距离 */
    }
    100% {
        transform: translateY(0);
    }
}
</style>